import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Button,
  IconButton,
} from '@chakra-ui/react'
import { DeleteIcon } from '@chakra-ui/icons'

interface Occupation {
  id?: string
  occupationName: string
  startDate: string
  endDate?: string
  stressLevel: string
}

interface OccupationTableProps {
  occupations: Occupation[]
  handleUpdateOccupation: (occupation: Occupation) => void
  handleDeleteOccupation: (id: string) => void
}

export default function OccupationTable({
  occupations,
  handleUpdateOccupation,
  handleDeleteOccupation,
}: OccupationTableProps) {
  // Helper to check if a date from BasicDateStringPicker is empty/incomplete
  const isDateEmpty = (date?: string) => {
    if (!date?.trim()) return true
    return date.startsWith('0-') || date.includes('-0-') || date.endsWith('-0')
  }

  return (
    <TableContainer mt={4}>
      <Table size='sm'>
        <Thead>
          <Tr>
            <Th>Actions</Th>
            <Th>Occupation Name</Th>
            <Th>Start Date</Th>
            <Th>End Date</Th>
            <Th>Stress Level</Th>
          </Tr>
        </Thead>
        <Tbody>
          {occupations?.map((occupation, index) => (
            <Tr key={index}>
              <Td>
                <Button
                  size='sm'
                  mr={1}
                  onClick={() => handleUpdateOccupation(occupation)}
                >
                  Update
                </Button>
                <IconButton
                  aria-label='Delete'
                  size='sm'
                  colorScheme='red'
                  variant='outline'
                  onClick={() =>
                    occupation.id && handleDeleteOccupation(occupation.id)
                  }
                  icon={<DeleteIcon />}
                />
              </Td>
              <Td>{occupation.occupationName}</Td>
              <Td>{occupation.startDate}</Td>
              <Td>
                {isDateEmpty(occupation.endDate)
                  ? 'Current'
                  : occupation.endDate}
              </Td>
              <Td>{occupation.stressLevel}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
